// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"RemoveSiteModal_buttonGroup__1wEth","infoText":"RemoveSiteModal_infoText__gg2c8"};